
export enum DateCycleType {
    Dividends = 1,
    Compounding = 2,
    RateFrequency = 4,
    Any = 255,
}